import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";

export const alumniSlice = createSlice({
  name: "alumniSlice",
  initialState: {
    opportunities: [],
    events: [],
    errorMessage: undefined,
    dataFetchingStatus: false,
    errorStatusCode: undefined,
  },
  reducers: {
    setOpportunities: (state, action) => {
      state.opportunities = action.payload;
    },
    setEvents: (state, action) => {
      state.events = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setErrorStatusCode: (state, action) => {
      state.errorStatusCode = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
  },
});

export const {
  setOpportunities,
  setEvents,
  setErrorMessage,
  setDataFetchingStatus,
  setErrorStatusCode,
} = alumniSlice.actions;

export const getOpportunities = () => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get("alumni/opportunities")
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setOpportunities(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getEvents = () => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  dispatch(setErrorMessage(undefined));
  dispatch(setErrorStatusCode(undefined));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get("alumni/events")
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setEvents(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const clearErrorStatusCode = () => (dispatch) => {
  dispatch(setErrorStatusCode(undefined));
};
export const clearErrorMessage = () => (dispatch) => {
  dispatch(setErrorMessage(undefined));
};

export default alumniSlice.reducer;
